import React from 'react';
import { Section, Kicker } from './Section';
export function FreezeMoment() {
  return <Section background="white" width="narrow" labelledBy="freeze-heading" data-id="element-128" data-mp="3gu1t0697xhg">
      <div className="text-center" data-id="element-129" data-mp="3dy15430uupb">
        <Kicker data-id="element-130" data-mp="3lmoub8fnz0x2">The moment this system was built for</Kicker>

        <h2 id="freeze-heading" className="mt-6 font-serif text-4xl font-semibold leading-[1.1] text-ink sm:text-5xl" data-id="element-131" data-mp="3pnije54uelrj">
          It's 8:57 AM.
        </h2>

        <p className="mt-7 font-sans text-[17px] leading-[1.65] text-ink-soft sm:text-lg" data-id="element-132" data-mp="3bu110nnw7f33">
          Your new client smiles, rolls out her mat, and says — casually — "Just so you know, I have
          two herniated discs. That's okay, right?" Class starts in three minutes. Twelve people are
          watching you. And your mind goes completely blank.
        </p>

        <p className="mt-9 font-serif text-2xl font-medium italic leading-snug text-brass sm:text-[28px]" data-id="element-133" data-mp="2syklwf5pk9qo">
          That blank isn't a knowledge problem. It's a missing protocol.
        </p>
      </div>
    </Section>;
}